// We are using react for some part in the framework. (comments, forms)
// So make sure these work if you override this
import 'xp-lib-brand/react/main-react';
import { MountMap } from 'xp-lib-brand/react/utils/mount';
import EventMap from './modules/eventMap/index';
import  Mount  from 'xp-lib-brand/react/utils/mount';


const eventCountdown = () => import(/* webpackChunkName: "eventCountdown" */ './modules/eventCountdown/index.jsx');
Mount('.eventCountdown', eventCountdown, ['endDate', 'completionText']);
MountMap('.eventMapRoot', EventMap, ['config', 'eventroot']);
